module.exports = __webpack_public_path__ + "img/help.d9aef70c.png";